import { FORM_VALIDATED } from './consts';
/**
 * 
 * @param {{
 * formValidated: boolean
 * }} data 
 * @returns {}
 */
export const FormData = ({ formValidated }) => ({
    [FORM_VALIDATED]: formValidated,
    init() {
        this.$el.noValidate = true;

        if (this[FORM_VALIDATED]) {
            this.$el.classList.add('form-validated');
        }

        this.$watch(FORM_VALIDATED, (newValue) => {
            this.$el.classList.toggle('form-validated', newValue);
        });
    },
    /**
     * 
     * @param {SubmitEvent} event 
     */
    handleSubmit(event) {
        if (this.$el.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();

            // Toggle formValidated to trigger field-level error message display.
            // The $watch on FORM_VALIDATED in each input field transitions them to
            // 'interacted' state, which surfaces their validation messages.
            this[FORM_VALIDATED] = false;
            this.$nextTick(() => {
                this[FORM_VALIDATED] = true;
            });

            // Move focus to the first invalid element
            const invalidElement = this.$el.querySelector(':invalid');
            if (invalidElement) {
                invalidElement.focus();
            }
            return;
        }
        this[FORM_VALIDATED] = true;

        if (window.RECAPTCHA_ENABLED && 
            this.$el.querySelector('input[name="g-recaptcha-response"]') && 
            typeof window.handleReCaptchaAndSubmit === 'function') {
            event.preventDefault();
            window.handleReCaptchaAndSubmit(this.$el, event.submitter);
            return;
        }
        // else, allow normal submit (browser will handle it)
    },
})